import React from "react";
import styled from "@emotion/styled";


interface QuoteProps {
    children?: React.ReactNode;
    cite: string;
    fontSize: string;
}

Quote.defaultProps = {
    fontSize: "33px",
}



export default function Quote( props: QuoteProps) {
    return (
        <Container fontSize={props.fontSize} >
            <blockquote>
                {props.children}
            </blockquote>
            <cite>{props.cite}</cite>
        </Container>
    );
}

const Container = styled.div<{fontSize:string}>`

  width: fit-content;
  margin: 120px auto;
  padding: 0 40px;

  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  
  @media (max-width: 768px) {
    margin: 80px auto;
  }
  
  blockquote {
    max-width: 800px;
    position: relative;
    margin: 0;
    padding: .3em;

    //font-family: YuMincho;
    font-weight: 500;
    font-size: ${(props) => props.fontSize};
    font-size: min(4vw, ${(props) => props.fontSize});
    text-align: center;
    color: #fff;
    line-height: 1.9em;
  }

  blockquote:before,
  blockquote:after {
    position: absolute;
    font-size: 2em;
    width: 1em;
    height: 1em;
    color: #ccc;
  }

  blockquote:before {
    content: '“';
    left: -0.8em;
    top: 0em;
  }

  blockquote:after {
    content: '”';
    right: -0.8em;
    bottom: 0em;
  }

  cite {
    margin-top: 20px;
    //font-family: YuMincho;
    line-height: 3em;
    text-align: left;
    font-size: 16px;
    color:#fff;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  
`